import classNames from 'classnames';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import Banner from 'src/components/banner/banner';
import { BANNER_TYPE } from 'src/constants/banner-type';
import Feedback from 'src/pages/feedback/feedback';
import AboutStats from './about-stats/about-stats';
import Customer from './customer/customer';
import css from './about-page.module.scss';
import SelectedMaterials from './selected-materials/selected-materials';
import Faq from './faq/faq';
import PartnersWrapper from './partners/partners-wrapper';
import RequestEmailModal from 'src/components/request-modal/request-email-modal';

export default function AboutPage() {
  return (
    <main className={css.aboutPage}>
      <Banner bannerType={BANNER_TYPE.general}>
        <h1>Інформаційна платформа для захисників, захисниць та їхніх родин</h1>
        <p className={css.subTitle}>
          Корисна інформація для військовослужбовців та їхніх родин, а також сімей полонених, зниклих безвісти,
          загиблих, поранених та військових звільнених з полону
        </p>
        <RequestEmailModal
          title='Запропонувати партнерство'
          trigger={
            <button id={css.partnerBanner} className={css.button}>
              <p>Запропонувати партнерство</p>
              <LinkArrow className={css.arrow} />
            </button>
          }
        />
      </Banner>
      <div className={css.body}>
        <AboutStats />
        <Customer />
        <div className={css.info}>
          <Banner bannerType={BANNER_TYPE.about}>
            <h1>Ключова інформація в єдиному місці</h1>
            <p className={css.subTitle}>
              Платформа забезпечує служби супроводу актуальними ресурсами, які допомагають здійснювати супровід швидше
              та ефективніше. Водночас кожен захисник та його родина можуть скористатися всіма перевагами для отримання
              швидкого доступу до важливої інформації
            </p>
          </Banner>
          <SelectedMaterials />
        </div>
        <Faq />
        <Banner bannerType={BANNER_TYPE.generalUsers}>
          <h1>Захисниками для захисників</h1>
          <p className={css.subTitle}>
            За підтримки Головнокомандувача Збройних Сил України сформували команду з військовослужбовців, які мали
            попередній досвід у сфері інформаційних технологій, а зараз реалізовують свої навички, щоб створити
            платформу для побратимів, посестер та їхніх сімей
          </p>
          <Feedback
            trigger={
              <button className={classNames(css.button, css.feedbackBanner)}>
                <p>Залишити відгук</p>
                <LinkArrow className={css.arrow} />
              </button>
            }
          />
        </Banner>
        <PartnersWrapper />
        <Banner bannerType={BANNER_TYPE.generalPartners}>
          <h1>Об'єднуємо державу, громадські організації та громади заради допомоги героям</h1>
          <div className={css.subTitleGroup}>
            <p className={css.subTitle}>
              Долучайтесь до платформи, щоб надати необхідну підтримку і допомогти захисникам та їхнім родинам
            </p>
          </div>
          <RequestEmailModal
            title='Запропонувати партнерство'
            trigger={
              <button className={css.button}>
                <p>Запропонувати партнерство</p>
                <LinkArrow className={css.arrow} />
              </button>
            }
          />
        </Banner>
      </div>
    </main>
  );
}
